import {
  UpdateAddressInput,
  UpdateAddressOutput,
} from "@redotech/redo-order-editing-common/schemas/update-address";

export const updateAddressSelfServe = {
  name: "updateAddressSelfServe" as const,
  input: UpdateAddressInput,
  output: UpdateAddressOutput,
};
